import {
  ThemedFunctor, SpacingName, getSpacing, BreakpointQueryName, getTypography, TypographyName,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const content: ThemedFunctor = ({
  theme,
  $fitMaxAvailableHeight,
}) => css`
  flex-grow: 1;
  position: relative;
  display: flex;

  ${$fitMaxAvailableHeight ? `
    height: 100%;
  ` : `
    /** Without a minimum height, browsers don't calculate the right height */
    min-height: 7.5rem;
  `}

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    background-color: ${theme.color.background.neutral.default.low};
  }
`;

export const header: ThemedFunctor = ({ theme }) => css`
  margin-bottom: ${theme.remSize[300]};
`;

export const headerContent: ThemedFunctor = ({ theme }) => css`

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: flex;
  }
`;

export const headerPrimary: ThemedFunctor = ({ theme }) => css`
  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    flex-grow: 1;
  }
`;

export const headerSecondary: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: flex-start;
  margin-top: ${theme.spaceUnits.mobile.SMALL};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    flex-shrink: 0;
    margin-top: 0;
  }
`;

export const subtitle: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLEST)}
  ${getTypography(theme, TypographyName.BODY)};
  display: flex;
  align-items: center;
  gap: .5rem;
`;

export const main: ThemedFunctor = () => css`
  position: relative;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overflow-x: hidden;
  flex: 1;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const mainContent: ThemedFunctor = ({
  theme,
  $fitMaxAvailableHeight,
}) => css`
  padding: ${theme.remSize[200]} 0 ${theme.remSize[1000]};

  ${$fitMaxAvailableHeight && `
    height: 100%;
    display: flex;
    flex-direction: column;
  `}

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    padding: ${theme.remSize[400]} 0;
  }
`;
